// // import React from 'react';
// // import AuditionForm from './AuditionForm';
// // // import AuditionDashboard from './AuditonDashbord';
// // function App() {
// //   return (
// //     <div>
// //       <AuditionForm/>
// //       {/* <AuditionDashboard/> */}
// //     </div>
// //   );
// // }

// // export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import AuditionForm from './AuditionForm';
// import AuditionDashboard from './AuditonDashbord';
// import ManageUsers from './ManageUsers';
// import LoginPage from './login';
// import Signup from './signup';    

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Default route → Audition Form */}
//         {/* <Route path="/" element={<AuditionForm />} /> */}
//         <Route path="/" element={<ManageUsers />} />

//         {/* Admin route with dynamic ID */}
//         <Route path="/adminDashboard/1234" element={<AuditionDashboard />} />
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/signup" element={<Signup />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// import AuditionForm from './AuditionForm';
// import AuditionDashboard from './AuditonDashbord';
// import ManageUsers from './ManageUsers';
// import LoginPage from './login';
// import Signup from './signup';

// // --- Protected Route for Admin ---
// const AdminRoute = ({ children }) => {
//   const role = localStorage.getItem('userRole');
//   return role === 'ADMIN' ? children : <Navigate to="/" />;
// };

// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem("authToken");
//   return token ? children : <Navigate to="/login" replace />;
// };


// function App() {
//   return (
//     <Router>
//       <Routes>

//         {/* Public Routes */}
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/signup" element={<Signup />} />

//         {/* PROTECTED DASHBOARD */}
//         <Route
//           path="/adminDashboard/1234"
//           element={
//             <ProtectedRoute>
//               <AuditionDashboard />
//             </ProtectedRoute>
//           }
//         />

//         {/* ADMIN ONLY */}
//         <Route
//           path="/manageUsers"
//           element={
//             <ProtectedRoute>
//               <AdminRoute>
//                 <ManageUsers />
//               </AdminRoute>
//             </ProtectedRoute>
//           }
//         />

//         {/* Default */}
//         <Route path="/" element={<LoginPage />} />
//         <Route path="/auditionForm" element={<AuditionForm />} />
//         <Route path="*" element={<Navigate to="/" />} />

//       </Routes>
//     </Router>
//   );
// }


// export default App;


//updated 23 Dec
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './login';
import AuditionDashboard from './AuditonDashbord';
import ManageUsers from './ManageUsers';
import AuditionForm from './AuditionForm';

/* -----------------------------------
   AUTH HELPERS
----------------------------------- */
const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

const isAdmin = () => {
  return localStorage.getItem('userRole') === 'ADMIN';
};

/* -----------------------------------
   PROTECTED ROUTES
----------------------------------- */
const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/auditions" replace />;
};

const AdminRoute = ({ children }) => {
  return isAuthenticated() && isAdmin()
    ? children
    : <Navigate to="/auditions" replace />;
};

/* -----------------------------------
   APP ROUTES
----------------------------------- */
function App() {
  return (
    <Router>
      <Routes>

        {/* 🔐 LOGIN (default entry point) */}
        <Route path="/auditions" element={<Login />} />

        {/* ✅ PUBLIC ROUTE */}
        <Route path="/auditions/auditionform" element={<AuditionForm />} />

        {/* 🔒 PROTECTED DASHBOARD */}
        <Route
          path="/adminDashboard/:id"
          element={
            <PrivateRoute>
              <AuditionDashboard />
            </PrivateRoute>
          }
        />

        {/* 🔒 ADMIN ONLY */}
        <Route
          path="/ManageUsers"
          element={
            <AdminRoute>
              <ManageUsers />
            </AdminRoute>
          }
        />

        

        

      </Routes>
    </Router>
  );
}

export default App;
